import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {IFolderPath} from "@interfaces/folder";
import {filter, map} from "rxjs/operators";

@Injectable()
export class FolderDirectoryService {
    constructor() {
    }

    private foldersPathTreeState$ = new BehaviorSubject<IFolderPath[]>([]);
    private _homeDir!: IFolderPath;

    // set initial directory
    public setHomeDir(homeFolderId: number) {
        const home = {name: 'Home', id: homeFolderId};
        this.foldersPathTreeState$.next([home])
        this._homeDir = home
    }

    public returnToTargetDirPath(targetPath: IFolderPath): void {
        // prevent double path emit
        if (targetPath.id === this.activeDirectory.id) return

        // find the place of target folder path
        const pos = this.foldersPathTreeState$.getValue().findIndex((path) => path.id === targetPath.id);
        // cut off the path tree behind target path
        const newArr = this.foldersPathTreeState$.getValue().slice(0, pos + 1);

        this.foldersPathTreeState$.next(newArr);
    }

    public setNextDirPath(path: IFolderPath): void {
        const newArr = [...this.foldersPathTreeState$.getValue(), path];
        this.foldersPathTreeState$.next(newArr);
    }

    // get the observable of activated dir path
    get activeDirectory$(): Observable<IFolderPath> {
        return this.pathTreeState$
            .pipe(
                map(arr => arr[arr.length - 1])
            )
    }

    get pathTreeState$(): Observable<IFolderPath[]> {
        // skip empty arr
        return this.foldersPathTreeState$.pipe(
            filter(arr => Boolean(arr.length))
        );
    }

    get pathTreeState(): IFolderPath[] {
        return this.foldersPathTreeState$.getValue();
    }

    get activeDirectory(): IFolderPath {
        const pathThree = this.foldersPathTreeState$.getValue();
        return pathThree[pathThree.length - 1];
    }

    get homeDir(): IFolderPath {
        return this._homeDir;
    }

    setFullTreePath(pathTree: IFolderPath[]): void {
        this.foldersPathTreeState$.next(pathTree);
    }
}
